export default {
  // 查询物流
  getLogisticsManagementJL: {
    method: 'get',
    url: '/api/getLogisticsManagementJL'
  },
  // 新增物流
  createLogisticsManagementJL: {
    method: 'post',
    url: '/api/createLogisticsManagementJL'
  },
  getGetLogisticsInfoJL: {
    method: 'get',
    url: '/api/getGetLogisticsInfoJL'
  },
  // 修改物流
  updateLogisticsManagementJL: {
    method: 'put',
    url: '/api/updateLogisticsManagementJL'
  },
  // 新增物流
  deleteLogisticsManagementJL: {
    method: 'delete',
    url: '/api/deleteLogisticsManagementJL'
  }
}
